<template>
  <b-form @submit.prevent="submitNewDomain">
    <b-form-group>
      <b-input-group>
        <b-form-input v-model="domainForm.unauthorizedDomain" placeholder="Enter Domain" required></b-form-input>
        <b-button type="submit" variant="primary">Add</b-button>
      </b-input-group>
    </b-form-group>
  </b-form>
</template>

<script>
import DomainEventBus from '@/xvisor/bus/DomainEventBus';

export default {
  data() {
    return {
      domainForm: {
        unauthorizedDomain: '',
      },
      addDomainUrl: '/policysettings/unauthorizedDomain/add',
    };
  },
  methods: {
    submitNewDomain() {
      this.$http
        .post(this.addDomainUrl, this.domainForm)
        .then(() => {
          this.$bvToast.toast('Successfully added approved Domain', { variant: 'success' });
          DomainEventBus.$emit('changed');
        })
        .catch(() => {
          this.$bvToast.toast('Failed to add approved Domain', { variant: 'danger' });
        });
    },
  },
};
</script>
